import { useRouter } from 'next/router';
import isPathnameMatch from '@modules/miscellaneous/common/utilities/isPathnameMatch';
import { assistantPathSuffix } from '../constants/assistantNavConstants';

const useIsAssistantActive = () => {
  const { pathname } = useRouter();
  return {
    isAssistantActive: isPathnameMatch({ pathname, targetPathSuffix: assistantPathSuffix }),
  };
};

export default useIsAssistantActive;
